/* eslint-disable consistent-default-export-name/default-export-match-filename -- The replacement keeps the upstream component name. */
import classNames from 'classnames';
import type { TFuncKey } from 'i18next';

import DynamicT from '@/shared/components/DynamicT';

import styles from './optical.module.scss';

type Props = {
  readonly className?: string;
  readonly label?: TFuncKey;
};

/** Centres the label's visible letters on the rule, not its line box. */
const Divider = ({ className, label }: Props) => (
  <div className={classNames(styles.divider, className)}>
    <i className={styles.line} />
    {label && (
      <>
        <span className={styles.label}>
          <DynamicT forKey={label} />
        </span>
        <i className={styles.line} />
      </>
    )}
  </div>
);

export default Divider;
/* eslint-enable consistent-default-export-name/default-export-match-filename */
